// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"909ece56","977":"eacef705"}[chunkId] + ".chunk.js";
};